import {laboratoryApi} from "@/container";
import useSwr from "@/core/composables/swr/useSwr";

/**
 * Composable to fetch laboratory videos.
 *
 * @param {string} laboratoryId The id of the laboratory.
 */
const useLaboratoryVideos = (laboratoryId?: string) => {
    const {data, error, isLoading} = useSwr(
        laboratoryId && `/laboratories/${laboratoryId}/videos`,
        () => laboratoryApi().patientPartnerLaboratoryVideos(Number(laboratoryId)),
    );

    return {
        data,
        error,
        isLoading
    };
};

export default useLaboratoryVideos;
